import { ContactDTO } from 'new-beginning/queries';

export const isContactPurchasable = (contact: ContactDTO) => contact?.hasPhone || contact?.hasEmail;
